import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './locales/en-US'
import zhTW from './locales/zh-TW'
import zhCN from './locales/zh-CN'

i18n.use(initReactI18next).init({
  resources: {
    'en-US': {
      translation: enUS,
    },
    'zh-TW': {
      translation: zhTW,
    },
    'zh-CN': {
      translation: zhCN,
    },
  },
  lng: 'zh-TW',
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n